import { alertStyle, buttonStyle } from './changeOrderStyles';
import NativeChangeOrderFields from './NativeChangeOrderFields';
import useNativeChangeOrderEditor from './useNativeChangeOrderEditor';

export default function ChangeOrderNativeEditor({
  jobId,
  token,
  items,
  editOrder,
  onEditConsumed,
  onSaved,
}) {
  const editor = useNativeChangeOrderEditor({
    jobId,
    token,
    items,
    editOrder,
    onEditConsumed,
    onSaved,
  });
  const locked = editor.previewing || editor.saving;

  return (
    <div style={{ marginTop: 12 }}>
      {!editor.open ? (
        <button type="button" onClick={editor.startNew} style={buttonStyle()}>
          Create native change order
        </button>
      ) : (
        <section
          aria-label="Native change order editor"
          style={{
            marginTop: 12,
            padding: 16,
            background: '#f2f6fb',
            border: '1px solid #dbe3ef',
            borderRadius: 9,
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              gap: 12,
              flexWrap: 'wrap',
            }}
          >
            <div>
              <h4 style={{ margin: '0 0 4px', color: '#26364d', fontSize: 14 }}>
                {editor.revisionOf ? 'Create a revision' : 'Create native draft'}
              </h4>
              <p style={{ margin: 0, color: '#68778b', fontSize: 12 }}>
                Review the generated PDF before saving. Saving creates a draft only; nothing is
                sent.
              </p>
            </div>
            <button
              type="button"
              onClick={editor.closeEditor}
              disabled={locked}
              style={buttonStyle()}
            >
              Close editor
            </button>
          </div>

          {editor.contextError && (
            <div role="alert" style={alertStyle}>
              {editor.contextError}{' '}
              <button
                type="button"
                onClick={() => editor.setContextAttempt((attempt) => attempt + 1)}
                style={{
                  border: 0,
                  padding: 0,
                  background: 'transparent',
                  color: '#1b3a6b',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
              >
                Retry context
              </button>
            </div>
          )}
          {editor.error && (
            <div role="alert" style={alertStyle}>
              {editor.error}
            </div>
          )}

          <NativeChangeOrderFields
            context={editor.context}
            jobId={jobId}
            fields={editor.fields}
            setField={editor.setField}
            files={editor.files}
            fileSize={editor.fileSize}
            retainedCount={editor.retainedCount}
            onFilesChange={editor.selectFiles}
            disabled={locked}
            isRevision={!!editor.revisionOf}
          />

          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <button
              type="button"
              onClick={editor.previewDraft}
              disabled={locked || !editor.context}
              style={buttonStyle()}
            >
              {editor.previewing ? 'Preparing preview…' : 'Preview draft'}
            </button>
            <button
              type="button"
              onClick={editor.saveDraft}
              disabled={locked}
              style={buttonStyle('primary')}
            >
              {editor.saving ? 'Saving draft…' : 'Save native draft'}
            </button>
          </div>
          {editor.previewUrl && (
            <div>
              <p style={{ fontSize: 12 }}>
                <a href={editor.previewUrl} target="_blank" rel="noopener noreferrer">
                  Open preview PDF
                </a>
                {' · '}
                <a href={editor.previewUrl} download="change-order-preview.pdf">
                  Download preview PDF
                </a>
                {' — Use these links if your browser cannot display the PDF below.'}
              </p>
              <iframe
                title="Native change order draft preview"
                src={editor.previewUrl}
                style={{
                  width: '100%',
                  height: 480,
                  border: '1px solid #dbe3ef',
                  borderRadius: 7,
                  marginTop: 12,
                  background: '#fff',
                }}
              />
            </div>
          )}
        </section>
      )}
    </div>
  );
}
